import React, { useEffect } from 'react';
import { Footer, Navbar } from '../components';
import { dataLayerPush } from '../helpers/dataLayer';

const Summary = () => {
  const [cart] = React.useState(localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []);

  const ShowCart = () => {
    let subtotal = 0;
    let shipping = 30.0;
    let totalItems = 0;
    cart.map((item) => {
      return (subtotal += item.price * item.qty);
    });

    cart.map((item) => {
      return (totalItems += item.qty);
    });

    dataLayerPush({
      event: 'pageView',
      pageType: 'summary',
      pageName: 'checkout',
      cart: cart,
      price: subtotal + shipping,
    });
    useEffect(() => {
      localStorage.removeItem('cart');
    }, []);
    return (
      <>
        <section className='h-100 gradient-custom'>
          <div className='container'>
            <div className='row d-flex justify-content-center my-4'>
              <div className='col-md-8'>
                <div className='mb-4 rounded-2' style={{ background: '#f9f9f9' }}>
                  <div className='p-3'>
                    {cart.map((item) => {
                      return (
                        <div key={item.id}>
                          <div className='row d-flex align-items-center'>
                            <div className='col-lg-3 col-md-12'>
                              <div className='bg-image rounded' data-mdb-ripple-color='light'>
                                <img src={item?.images?.main} className='w-50 mx-5' alt={item.title} />
                              </div>
                            </div>

                            <div className='col-lg-5 col-md-6'>
                              <p>{item.title}</p>
                            </div>

                            <div className='col-lg-4 col-md-6'>
                              <p className='text-end mx-5' style={{ fontWeight: 500 }}>
                                <span className='text-muted'>{item.qty}</span> x ${item.price}
                              </p>
                            </div>
                          </div>

                          <hr className='my-4' />
                        </div>
                      );
                    })}
                    <ul className='list-group list-group-flush mx-5'>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0'
                        style={{ background: '#f9f9f9' }}>
                        Order Total ({totalItems})<span>${subtotal}</span>
                      </li>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center px-0'
                        style={{ background: '#f9f9f9' }}>
                        Shipping
                        <span>${shipping.toFixed(2)}</span>
                      </li>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3'
                        style={{ background: '#f9f9f9' }}>
                        <div style={{ fontWeight: 500 }}>Total amount</div>
                        <span style={{ fontWeight: 500 }}>${(subtotal + shipping).toFixed(2)}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}>
        <Navbar />
        <div className='container my-5 py-2' style={{ flex: '1' }}>
          <h1 className='text-center fw-light'>Thanks for your order</h1>
          <hr />
          <ShowCart />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Summary;
